import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from '@utilities/SplitText';
import nestedLinesSplit from '@utilities/NestedLinesSplit';

import core from '@/core';
import stateManager from '@/StateManager';

Alpine.plugin(persist);
window.Alpine = Alpine;

gsap.registerPlugin(ScrollTrigger);
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
window.SplitText = SplitText;
window.nestedLinesSplit = nestedLinesSplit;

console.log(
    `%cCrafted with ❤ by https://whiteboard.is`,
    'background: #8FBF26; color: #ffffff; font-size: 13px; padding: 4px 8px;'
);

stateManager();
core();

window.onload = () => {
    Alpine.start();
    routes.loadEvents();
};
